import { format } from "date-fns";
import { CandidateInterviewType } from ".";
import * as domain from "../../../domain";

export class CandidateInterviewFormData {
    candidateInterviewId: number;
    interviewDate: string;
    interviewTime: string;
    durationHours: number;
    durationMinutes: number;
    timeZoneId: number | undefined;
    interviewTypeId: number | undefined;
    interviewStatusTypeId: number;
    interviewDetails: string | undefined;
    sendNotification: boolean;

    private constructor(interviewData: CandidateInterviewType) {
        const defaultInitialDate = new Date(
            new Date().getTime() + 7 * 24 * 60 * 60 * 1000
        );
        const defaultInitialStartDate = format(
            defaultInitialDate,
            "yyyy-MM-dd"
        );

        this.candidateInterviewId = interviewData.candidateInterviewId;
        this.interviewDate =
            interviewData.interviewDate || defaultInitialStartDate;
        this.interviewTime = interviewData.interviewTime || "";
        this.durationHours =
            interviewData.durationHours === undefined ||
            interviewData.durationHours === null
                ? 1
                : interviewData.durationHours;
        this.durationMinutes = interviewData.durationMinutes || 0;
        this.timeZoneId = interviewData.timeZoneId;
        this.interviewTypeId = interviewData.interviewTypeId;
        this.interviewStatusTypeId =
            interviewData.interviewStatusTypeId ||
            domain.InterviewStatusEnum.SCHEDULED.id;
        this.interviewDetails = interviewData.interviewDetails === undefined
                ? null
                : interviewData.interviewDetails;
        this.sendNotification = interviewData.sendNotification === undefined
                ? false
                : interviewData.sendNotification;
    }

    static create = (
        interviewData: CandidateInterviewType
    ): CandidateInterviewFormData =>
        new CandidateInterviewFormData(interviewData);
}
